import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "./ComicReader.css";

export default function ComicReader() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const paginas = location.state?.paginas || [];
  const titulo = location.state?.titulo || "Comic Viewer";

  const [paginaActual, setPaginaActual] = useState(Number(id) || 0);
  const [modoCascada, setModoCascada] = useState(false); // 👈 Nuevo estado

  const siguiente = () => {
    if (paginaActual < paginas.length - 1) setPaginaActual(paginaActual + 1);
  };

  const anterior = () => {
    if (paginaActual > 0) setPaginaActual(paginaActual - 1);
  };

  const volver = () => navigate(-1);

  const cambiarPagina = (e) => {
    setPaginaActual(Number(e.target.value));
  };

  const toggleCascada = () => {
    setModoCascada(!modoCascada);
  };

  // === ESCUCHAR TECLAS ===
  useEffect(() => {
    const manejarTeclas = (e) => {
      if (!modoCascada) {
        if (e.key === "ArrowRight") siguiente();
        else if (e.key === "ArrowLeft") anterior();
      }
    };

    window.addEventListener("keydown", manejarTeclas);
    return () => window.removeEventListener("keydown", manejarTeclas);
  }, [paginaActual, modoCascada]);


  return (
    <div className="comic-container">
      {/* === BARRA SUPERIOR === */}
      <div className="comic-topbar">
        <button className="nav-btn" onClick={volver}>← Volver</button>
        <span className="comic-logo">⚡ {titulo}</span>
        <div className="comic-controls">
          <button className="nav-btn" onClick={toggleCascada}>
            🌊 {modoCascada ? "Normal" : "Cascada"}
          </button>

          {!modoCascada && (
            <>
              <button className="nav-btn" onClick={anterior}>◀ Anterior</button>
              <button className="nav-btn" onClick={siguiente}>Siguiente ▶</button>
              <select
                className="page-select"
                value={paginaActual}
                onChange={cambiarPagina}
              >
                {paginas.map((_, index) => (
                  <option key={index} value={index}>
                    Página {index + 1}
                  </option>
                ))}
              </select>
            </>
          )}
        </div>
      </div>
<div
  className={`comic-viewer ${!modoCascada ? "touch-nav" : ""}`}
  onTouchStart={(e) => {

    if (modoCascada) return;

    const toque = e.touches[0];

    const mitad = window.innerWidth / 2;

    if (toque.clientX < mitad) {
      anterior();
    } else {
      siguiente();
    }
  }}
>
    {paginas.length > 0 ? (
    modoCascada ? (
      // --- MODO CASCADA ---
      paginas.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`Página ${index + 1}`}
          className="comic-page cascada"
        />
      ))
    ) : (
      // --- MODO NORMAL ---
      <img
        src={paginas[paginaActual]}
        alt={`Página ${paginaActual + 1}`}
        className="comic-page"
      />
    )
  ) : (
    <p style={{ color: "#00eaff" }}>⚠ No hay páginas disponibles</p>
  )}
</div>

      {/* === PIE DE PÁGINA === */}
      <div className="comic-footer">
        © 2025 TMOXNight — Lector Futurista 💫
      </div>
    </div>
  );
}
